import {configurationReducer} from '../features/configuration/configuration-slice.js';

export const configuration = configurationReducer;
